import _ from "lodash";
import {canPublishAnimals} from "../animal/utils";

export async function getCNDANotificationData(groupId) {

    const users = await global.app.C.CUser.find({
        fieldPath: ['kpUser.id', 'kpUser.k', 'organization.organizationType.id'],
        group: new global.ObjectID(groupId)
    })

    // Animals waiting for the CNDA validation, only notified to the contacts allowed to publish them
    // (contacts of internal organizations, Keenpoint accounts excluded, see animal/utils canPublishAnimals).
    const animalsToValidate = await global.app.C.Animal.find({
        query: {adoptionStatus: 'submittedForValidation'},
        fieldPath: ['id'],
        group: new global.ObjectID(groupId),
        tc: d => d
    })

    const submitterFiles = await global.app.C.ReliefFund.find({
        query: {status: 'questioned'},
        fieldPath: ['submitter.id'],
        group: new global.ObjectID(groupId),
        tc: d => d
    })

    const controllerFiles = await global.app.C.ReliefFund.find({
        query: {status: {$in: ['ongoing', 'updated']}},
        fieldPath: ['id'],
        group: new global.ObjectID(groupId),
        tc: d => d
    })

    const validatorFiles = await global.app.C.ReliefFund.find({
        query: {status: 'controlled'},
        fieldPath: ['id'],
        group: new global.ObjectID(groupId),
        tc: d => d
    })

    const payerFiles = await global.app.C.ReliefFund.find({
        query: {status: 'accepted'},
        fieldPath: ['id',
            'totalAwardedAmountsInEuros', 'totalValidatedAmountsInEuros',
            'totalAwardedAmountsInKilograms', 'totalValidatedAmountsInKilograms',
            'payments.id', 'payments.status'
        ],
        group: new global.ObjectID(groupId),
        tc: d => d
    })

    return users.filter(cUser => !!_.get(cUser, 'kpUser.id')).reduce((acc, cUser) => ({
        [cUser.kpUser.id]: {
            'm-C-submission': submitterFiles.filter(file => file.submitter.id === cUser.kpUser.id).length,
            'm-C-study': controllerFiles.length,
            'm-C-decision': validatorFiles.length,
            'm-C-reliefFundPayment': payerFiles.length, //payerFiles.filter(file => file.totalAwardedAmountsInEuros > file.totalValidatedAmountsInEuros || file.totalAwardedAmountsInKilograms > file.totalValidatedAmountsInKilograms).length,
            'm-C-reliefFundPaymentValidation': payerFiles.flatMap(file => file.payments.filter(payment => payment.status.id === 'ongoing')).length,
            'm-C-animal': canPublishAnimals(cUser, {user: cUser.kpUser}) ? animalsToValidate.length : 0
        },
        ...acc
    }), {})
}
